import {Typography, IProps as ITypographyProps} from 'components/Typography';
import {FC} from 'react';
import {TPropsWithClassName} from 'core/types';

import style from './style.module.scss';
import classNames from 'classnames';

interface IProps extends TPropsWithClassName, ITypographyProps {}
export const Chips: FC<IProps> = ({children, className, variant = 'label-14-r', ...args}) => {
    return (
        <Typography className={classNames(className, style.chips)} {...args} variant={variant}>
            {children}
        </Typography>
    );
};
